import * as Yup from 'yup';
import { WorkOrder } from '@models';

export function useValidationSchema() {
  const getMaxLengthSchema = (max: number) =>
    Yup.string()
      .max(max, `Poznámka môže obsahovať maximálne ${max} znakov.`)
      .nullable();
  return Yup.object<WorkOrder>().shape({
    workOrderId: Yup.number().nullable(),
    operationNumber: Yup.number().nullable(),
    note: Yup.string().when('systemName', {
      is: (systemName: string) => systemName.startsWith('SAPWM'),
      then: () => getMaxLengthSchema(220),
      otherwise: () => getMaxLengthSchema(4000),
    }),
  }) as Yup.Schema<WorkOrder>;
}
